var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 7.354,
    viewBox: "0 0 10 7.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_245",
    "data-name": "Subtraction 245",
    d: "M-1297.821,14224.854a1.027,1.027,0,0,1-.729-.3l-2.648-2.646a1.011,1.011,0,0,1-.3-.725,1.042,1.042,0,0,1,.3-.73,1.022,1.022,0,0,1,.73-.3,1.022,1.022,0,0,1,.729.3l1.919,1.92,4.564-4.566a1.013,1.013,0,0,1,.727-.3,1.028,1.028,0,0,1,.729.3,1.03,1.03,0,0,1,.3.73,1.01,1.01,0,0,1-.3.725l-5.294,5.293A1.023,1.023,0,0,1-1297.821,14224.854Z",
    transform: "translate(1301.5 -14217.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectTick);
export default __webpack_public_path__ + "static/media/selectTick.becd444c9101b433f7d8d7ab29ea525d.svg";
export { ForwardRef as ReactComponent };